<mat-card class="container">
  <ng-content></ng-content>
</mat-card>
